import Layout from 'src/components/Octopath/layout';
import 'src/styles/table.scss';
import React from 'react';
export default {
  Layout,
  React
};